import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StyledUpdatedDate = styled.div`
  color: #c2c3c3;
  position: absolute;
  bottom: 0;
  ${props => (props.placementH === 'left' ? 'left' : 'right')}: 0;
  background: white;
  font-size: 12px;
  padding: 10px;
  border-bottom-${props =>
    props.placementH === 'left' ? 'left' : 'right'}-radius: 5px;
`;

class UpdatedDate extends PureComponent {
  render() {
    return (
      <StyledUpdatedDate placementH={this.props.placementH}>
        {this.props.children}
      </StyledUpdatedDate>
    );
  }
}

export default UpdatedDate;
